import React from "react";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  useRoutes,
} from "react-router-dom";
import AboutUs from "./pages/AboutUs";
import NewsCategoryView from "./pages/NewsCategoryView";
import Jobs from "./pages/Jobs";

import JobSingle from "./pages/JobSingle";
import Profile from "./pages/Profile";
import SubscriptionStatus from "./pages/SubscriptionStatus";
import HomePage from "./pages/HomePage";
import SingleNews from "./pages/SingleNews";
import Faqs from "./pages/Faqs";
import Termsofuse from "./pages/Termsofuse";
import Pricing from "./pages/Pricing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ContactUs from "./pages/ContactUs";
import { useEffect } from "react";
import ScrollToTop from "./ScrollToTop";
import { useState } from "react";
import Preloader from "./components/preloader";

const App = () => {
  let routes = useRoutes([
    // new routes
    { path: "/", element: <HomePage /> },
    { path: "/about-us", element: <AboutUs /> },
    { path: "/news/:newsslug", element: <SingleNews /> },
    { path: "/news/category/:category", element: <NewsCategoryView /> },
    { path: "/login", element: <Login /> },
    { path: "/register", element: <Register /> },
    { path: "/profile", element: <Profile /> },
    { path: "/pricing", element: <Pricing /> },
    { path: "/jobs", element: <Jobs /> },
    { path: "/jobs/:jobId", element: <JobSingle /> },
    { path: "/subscription/payment", element: <SubscriptionStatus /> },
    { path: "/subscription/cancelled", element: <SubscriptionStatus /> },


    // uncompleted routes 
    { path: "/faqs", element: <Faqs /> },
    { path: "/termsofuse", element: <Termsofuse /> },
    { path: "/contact-us", element: <ContactUs /> },
  ]);
  return routes;
};

const AppWrapper = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  return (
    <>
      {!loading ? (
        <Router>
          <ScrollToTop />
          <App />
        </Router>
      ) : (
        <Preloader />
      )}
    </>
  );
};

export default AppWrapper;
